import logo from '../../../../assets/logos/masylogofont.png';
import { Container } from '../../../../components/common';
import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import NavbarLinksEN from '../NavbarLinksEN';
import { Wrapper } from './styles';

const Navbar = () => (
  <header>
    <Wrapper as={Container}>
      <div style={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
        <Link to="/">
          <img src={logo} alt="Maksymilian Grela" />
        </Link>

        <Link to="/">
          <Language>Polska Wersja</Language>
        </Link>
      </div>

      <NavbarLinksEN desktop />
    </Wrapper>
  </header>
);

export default Navbar;

export const Language = styled.section`
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 5px;
  transistion: 0.3s;
  font-weight: 700;

  &:hover {
    color: #cb2027;
  }
`;
